import { useAppSelector } from './useAppSelector';
import { useAppDispatch } from './useAppDispatch';
import { fetchStats } from '../store/slice/stats-slice';
import { StatsFetchType } from '../enum/StatsFetchType';
import { useLocation } from 'react-router-dom';
import { fetchCashRegisterData } from '../store/slice/cash-register-slice';
import { GeoClass } from '../interface/response/GeoFiltersResponse';
import { CASH_REGISTER_URL } from '../util/url';
import { getFinalUTCDateRange } from './useFormatDateTime';

/**
 * Applies all selected filters to the dataset and updates the table.
 *
 * This function retrieves the current global filters and date range from the Redux store,
 * combines them into a single filter object, and applies them to the dataset.
 * It then updates the table to reflect the filtered data.
 *
 */

export const useAllFilters = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.globalFilters);
  const range = useAppSelector((state) => state.dateFilter);
  const location = useLocation();
  const currentPath = location.pathname;
  const selectedZone = useAppSelector((state) => state.configSlice.timeZone);
  const { startDate, endDate } = getFinalUTCDateRange(range, selectedZone);

  const handleApplyAllFilters = async () => {
    try {
      const commonDate = {
        StartDate: startDate,
        EndDate: endDate,
      };

      const selectedGroups = filters.Group || [];

      if (currentPath === CASH_REGISTER_URL) {
        const payload = {
          GroupID: filters.Group && filters.Group.length > 0 ? selectedGroups[0].ID : null,
          LocationID:
            filters.Location && filters.Location.length > 0 ? filters.Location.map((l: GeoClass) => l.ID) : null,
          From: range.from,
          To: range.to,
          PageNumber: 1,
          PageSize: 20,
        };

        dispatch(fetchCashRegisterData(payload));
      } else {
        dispatch(
          fetchStats({
            type: StatsFetchType.STATS,
            request: {
              Date: commonDate,
              clients: filters.Client?.length ? filters.Client.map((c: GeoClass) => c.ID) : null,
              companies: filters.Company?.length ? filters.Company.map((c: GeoClass) => c.ID) : null,
              regions: filters.Region?.length ? filters.Region.map((r: GeoClass) => r.ID) : null,
              groups: filters.Group?.length ? filters.Group.map((g: GeoClass) => g.ID) : null,
              locations: filters.Location?.length ? filters.Location.map((l: GeoClass) => l.ID) : null,
              games: filters.Games?.length ? filters.Games.map((g: GeoClass) => Number(g.ID)) : null,
              paymentSources: filters.PaymentSource?.length ? filters.PaymentSource.map((p: GeoClass) => p.ID) : null,
              statisticBy: filters.GameActivity?.id ?? null,
              hasTestData: filters.TestData?.id ?? null,
            },
          }),
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  return {
    handleApplyAllFilters,
  };
};
